import BranchTypes from './branch.types';
import { decodeHexResponse } from '../_common/common.utils';

const INITIAL_STATE = {
	createBranchResponse: null,
	updateBranchResponse: null,
	getBranchResponse: null,
	getBranchesByOrganisationResponse: null,
	getBranchByIdResponse: null,
};

const branchReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	switch (action.type) {
		// Create Branch
		case BranchTypes.CREATE_BRANCH_START:
			return { ...state, createBranchResponse: null };
		case BranchTypes.CREATE_BRANCH_SUCCESS:
			return {
				...state,
				createBranchResponse: decodeHexResponse(
					action.payload,
					BranchTypes.CREATE_BRANCH_KEY,
				),
			};
		case BranchTypes.CREATE_BRANCH_FAILURE:
			return {
				...state,
				createBranchResponse: decodeHexResponse(
					action.payload,
					BranchTypes.CREATE_BRANCH_KEY,
				),
			};

		// Update Branch
		case BranchTypes.UPDATE_BRANCH_START:
			return { ...state, updateBranchResponse: null };
		case BranchTypes.UPDATE_BRANCH_SUCCESS:
			return {
				...state,
				updateBranchResponse: decodeHexResponse(
					action.payload,
					BranchTypes.UPDATE_BRANCH_KEY,
				),
			};
		case BranchTypes.UPDATE_BRANCH_FAILURE:
			return {
				...state,
				updateBranchResponse: decodeHexResponse(
					action.payload,
					BranchTypes.UPDATE_BRANCH_KEY,
				),
			};
		// Get Branches By Organisation
		case BranchTypes.GET_BRANCHES_BY_ORGANISATION_START:
			return { ...state };
		case BranchTypes.GET_BRANCHES_BY_ORGANISATION_SUCCESS:
			return {
				...state,
				getBranchesByOrganisationResponse: decodeHexResponse(
					action.payload,
					BranchTypes.GET_BRANCHES_BY_ORGANISATION_KEY,
				),
			};
		case BranchTypes.GET_BRANCHES_BY_ORGANISATION_FAILURE:
			return { ...state, getBranchesByOrganisationResponse: action.payload };
		// Get Branch By Id
		case BranchTypes.GET_BRANCH_BY_ID_START:
			console.log('GET_BRANCH_BY_ID_START - Clearing previous data');
			return { ...state, getBranchByIdResponse: null };
		case BranchTypes.GET_BRANCH_BY_ID_SUCCESS:
			console.log('GET_BRANCH_BY_ID_SUCCESS - Storing data:', action.payload);
			console.log('Data type:', typeof action.payload);
			console.log('Data keys:', Object.keys(action.payload || {}));
			return {
				...state,
				getBranchByIdResponse: decodeHexResponse(action.payload, 'getBranchByIdKey'),
			};
		case BranchTypes.GET_BRANCH_BY_ID_FAILURE:
			console.log('GET_BRANCH_BY_ID_FAILURE - Error:', action.payload);
			return {
				...state,
				getBranchByIdResponse: decodeHexResponse(action.payload, 'getBranchByIdKey'),
			};

		default:
			return state;
	}
};

export default branchReducer;
